import { getAuthForChatSocket, setChatApiBase } from 'api/auth'
import { getAuthForSocketConnection } from 'modules/session/utils'
import { generatePresenceContext } from 'modules/visitorPresence'
import { Channel, Socket } from 'phoenix'
import { throttle } from 'throttle-debounce'
import { CHANNEL_EVENTS, connectToChannel, connectToSocket,SOCKET_CHANNELS, SOCKET_CLUSTER } from 'utils/socket'

import { PRESENCE_PING_THROTTLE } from '../constants'
import SocketManager from '../socketManager'

interface SocketConnectProps {
  accessToken: string,
  orgId: number,
}

interface ChatBootstrapEventArgs {
  sessionId: string,
  accessToken: string,
  campaignIds: number[]
}

class ChatSocketManager extends SocketManager {
  _heartbeatInterval: number
  _socket: Socket
  _channel: { channel: Channel }

  constructor() {
    super()
    this._socket = null
    this._channel = null
    this._heartbeatInterval = null
  }

  async connect({ accessToken, orgId }: SocketConnectProps) {
    setChatApiBase(orgId)

    const socketChatAuth = await getAuthForSocketConnection({
      fn: getAuthForChatSocket,
      socketCluster: SOCKET_CLUSTER.CHAT,
      token: accessToken
    })

    this._socket = await connectToSocket({
      ip: socketChatAuth.remote_ip,
      org_id: orgId,
      session_token: socketChatAuth.session_token,
      socketCluster: SOCKET_CLUSTER.CHAT,
    })

    this._fireSocketConnectedEvent(SOCKET_CLUSTER.CHAT)

    this._channel = await connectToChannel({
      socket: this._socket,
      channelEvents: CHANNEL_EVENTS.USER,
      channelName: SOCKET_CHANNELS.USER,
      orgId,
      socketAuth: socketChatAuth,
    })

    this._fireChannelConnectedEvent('user', SOCKET_CLUSTER.CHAT, this._channel)

    if (this._channel) {
      this._sendPresencePing()
      this._channel.channel.on('presence:request_update', () => {
        this.throttledPresencePing()
      })
    }
  }


  _sendPresencePing = async () => {
    if (!this._channel) {
      return
    }

    const { page } = await generatePresenceContext()
    this._channel.channel.push('presence:send_update', { page })
  }

  throttledPresencePing = throttle(PRESENCE_PING_THROTTLE, false, this._sendPresencePing)
}

export default new ChatSocketManager()
